import { merchantReclaimAccessDefaultsSchema } from "@redotech/redo-model/disputes/reclaim-access-settings";
import * as z from "zod/v4";

export const getReclaimAccessDefaults = {
  name: "getReclaimAccessDefaults" as const,
  input: z.object({}),
  output: z.object({ defaults: merchantReclaimAccessDefaultsSchema }),
};
